import {MessageCodes} from "../MessageCodes";
import ResultHeader from "../../Table/ResultHeader";
import ResultRow from "../../Table/ResultRow";
import ResultBody from "../../Table/ResultBody";
import ResultBodyCell from "../../Table/ResultBodyCell";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import ResultCellHighlight from "../../Table/ResultCellHighlight";
import ResultTable from "../../Table/ResultTable";
import EmptyLine from "../../EmptyLine";
import ComparisonCSName from "../../ComparisonCSName";
import {useUser} from "../../../Context/UserContext";
import HecRasHelper from "../../../Helpers/HecRasHelper";
import ResultText from "../ResultText";
import ResultView from "../../V2/ResultView";
import CheckCSName from "../../CheckCSName";

export function C6({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Compare.M006.error_id: {
            return (
                <>
                    <ResultText>
                        There are differences in the Manning’s n value at the following {row.data.length} cross sections.
                        <EmptyLine />
                        <ComparisonCSName csNameList={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))} />
                        <EmptyLine />
                    </ResultText>
                    <ResultText>
                        {
                            row.data.map(r => {
                                return renderMannData(r, globalVariables)
                            })
                        }
                    </ResultText>
                </>
            )
        }
        case MessageCodes.Compare.MICS006.error_id: {
            return (
                <>
                    <ResultText>
                        There are differences in the Manning’s n value at the following {row.data.length} Internal Bridge Cross Sections.
                        <EmptyLine />
                        <ComparisonCSName csNameList={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))} />
                        <EmptyLine />
                    </ResultText>
                    <ResultText>
                        {
                            row.data.map(r => {
                                return renderMannData(r, globalVariables)
                            })
                        }
                        <br/>
                    </ResultText>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}

const renderMannData = (row, globalVars) => {
    const tables = []
    const chunkSize = 7;
    for (let i = 0; i < row?.matched_table?.length; i += chunkSize) {
        const match_table_data = row?.matched_table?.slice(i, i + chunkSize);
        tables.push((
            <ResultTable>
                <ResultHeader>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(15)}}>
                            {(i === 0) && (<ComparisonCSName csName={row.cross_section} />)}
                        </ResultHeaderCell>
                        {
                            match_table_data.map((r, idx) => (
                                <ResultHeaderCell colSpan={2}>
                                    <b>{r?.number ? `n#${r.number}` : `-`}</b>
                                </ResultHeaderCell>
                            ))
                        }
                    </ResultRow>
                </ResultHeader>

                <ResultBody>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(15)}}>
                            <b>{globalVars?.sel_plan_title || 'Base'}</b>
                        </ResultHeaderCell>
                        {
                            match_table_data.map(y => {
                                let bgColor = ''
                                if(row?.base_chn_indexes?.includes(y.number-1))
                                    bgColor = '#C0FFC8'

                                return (
                                    <>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{y?.base_station?.toString() || '-'}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right', backgroundColor: bgColor}}>{y?.base_val || '-'}</ResultBodyCell>
                                    </>
                                )
                            })
                        }
                    </ResultRow>

                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(15)}}>
                            <b>{globalVars?.tar_plan_title || 'Base'}</b>
                        </ResultHeaderCell>
                        {
                            match_table_data.map(y => {
                                let bgColor = ''
                                if(row?.cmp_chn_indexes?.includes(y.number-1))
                                    bgColor = '#C0FFC8'

                                return (
                                    <>
                                        <ResultBodyCell style={{textAlign: 'right', width: HecRasHelper.getWidth(5)}}>{ResultCellHighlight(y?.base_station?.toString() || '-', y?.cmp_station?.toString() || '-')}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right', width: HecRasHelper.getWidth(5), backgroundColor: bgColor}}>{ResultCellHighlight(y?.base_val || '-', y?.cmp_val || '-')}</ResultBodyCell>
                                    </>
                                )
                            })
                        }
                    </ResultRow>
                </ResultBody>
            </ResultTable>
        ))
        // do whatever
    }

    return (
        <div style={{overflowX: 'auto', paddingBottom: 8, overflowY: 'auto'}}>
            {tables}
        </div>
    )
}